import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import jwt_decode from "jwt-decode";

import Mainsite from "./components/TemplateSite";
import Login from "./components/Login";
import resultsService from "./Services/resultsService";
import auth from "./Services/loginService";
import getTheme from "./theme/theme";

const jcc = require("json-case-convertor");

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

function App(props) {
  const mode = props.darkMode ? "dark" : "light";
  const theme = useMemo(() => getTheme(mode), [mode]);

  useEffect(() => {
    if (props.userDetails) {
      const userDetails = jcc.snakeCaseKeys(props.userDetails);

      resultsService.getBloodP().then((r) => props.updateBloodPResults(r.data));
      resultsService
        .getActivities()
        .then((r) => props.updateActivitiesResults(r.data));
      resultsService.getInvoices().then((r) => props.updateInvoices(r.data));
      resultsService.getHafnayot().then((r) => props.updateHafnayot(r.data));
      resultsService
        .getCardioR()
        .then((r) => props.updateCardioRResults(r.data));
      resultsService.getEcgs().then((r) => props.updateEcgResults(r.data));
      resultsService
        .getWeights()
        .then((r) => props.updateWeightResults(r.data));
      resultsService.getPatients().then((r) => {
        props.updatePatients(r.data);
        if (userDetails?.ipermit === 1) {
          props.updateSelectedPAtient(r.data[0]);
        }
      });
    } else if (localStorage.getItem("token")) {
      const token = localStorage.getItem("token");
      try {
        const decodedToken = jwt_decode(token);
        const currentDate = new Date();
        if (decodedToken.exp * 1000 >= currentDate.getTime()) {
          props.updateUserDetails(auth.getCurrentUser());
        } else {
          localStorage.removeItem("token");
          props.logout(undefined);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [props.userDetails]);
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <div className="App" dir="rtl">
            <Routes>
              <Route path="/" element={<Mainsite />} />
              <Route path="/login" element={<Login />} />
              <Route path=":page" element={<Mainsite />} />
            </Routes>
          </div>
        </Router>
      </ThemeProvider>
    </CacheProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
    darkMode: state.darkMode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateBloodPResults: (bloodP) =>
      dispatch({ type: "UPDATE_BLOODP_RESULTS", payload: bloodP }),
    updateSelectedPAtient: (patient) =>
      dispatch({ type: "UPDATE_SELECTED_PATIENT", payload: patient }),
    updateInvoices: (invoices) =>
      dispatch({ type: "UPDATE_INVOICES", payload: invoices }),
    updateHafnayot: (hafnayot) =>
      dispatch({ type: "UPDATE_HAFNAYOT", payload: hafnayot }),
    updateUserDetails: (newDetails) =>
      dispatch({ type: "UPDATE_USER_DETAILS", payload: newDetails }),
    updateWeightResults: (weights) =>
      dispatch({ type: "UPDATE_WEIGHT_RESULTS", payload: weights }),
    updateEcgResults: (ecgs) =>
      dispatch({ type: "UPDATE_ECG_RESULTS", payload: ecgs }),
    updateActivitiesResults: (activities) =>
      dispatch({ type: "UPDATE_ACTIVITIES_RESULTS", payload: activities }),
    updateCardioRResults: (cardioR) =>
      dispatch({ type: "UPDATE_CARDIOR_RESULTS", payload: cardioR }),
    logout: (newDetails) => dispatch({ type: "LOGOUT", payload: newDetails }),
    updatePatients: (patients) =>
      dispatch({ type: "UPDATE_PATIENTS", payload: patients }),
    toggleDarkMode: (val) =>
      dispatch({ type: "TOGGLE_DARK_MODE", payload: val }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
